import { useAppointmentSlotsByFirstAvailableQuery } from "~/services/scheduling";

export const useGetFirstAvailableSlots =
  useAppointmentSlotsByFirstAvailableQuery;
